/* eslint-disable */
export default {
  unmute: 'Dempen uitschakelen',
  mute: 'Dempen',
  keypad: 'Toetsenblok',
  hold: 'Wacht',
  onHold: 'In de wacht',
  park: 'Parkeren',
  stopRecord: 'Stoppen',
  record: 'Opnemen',
  add: 'Toevoegen',
  transfer: 'Doorschakelen',
  flip: 'Omkeren',
  more: 'Oproepacties',
  mergeToConference: 'Samenvoegen',
  end: 'Beëindigen',
  completeTransfer: 'Doorschakelen\nvoltooien',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
